var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delivery-page" },
    [
      _c("van-nav-bar", {
        attrs: {
          title: _vm.isReadOnly ? "物流信息" : "填写收货地址",
          "left-arrow": ""
        },
        on: {
          "click-left": function($event) {
            return _vm.$router.go(-1)
          }
        }
      }),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "loading-skeleton" }, [
            _c("div", { staticClass: "skeleton-block" }),
            _vm._v(" "),
            _c("div", { staticClass: "skeleton-block" })
          ])
        : _vm.isReadOnly && _vm.deliveryInfo
        ? [
            _c(
              "div",
              {
                staticClass: "status-hero",
                class: "hero-status-" + _vm.deliveryInfo.DeliveryStatus
              },
              [
                _c("div", { staticClass: "hero-icon" }, [
                  _vm.deliveryInfo.DeliveryStatus === 2
                    ? _c("span", [_vm._v("📮")])
                    : _vm.deliveryInfo.DeliveryStatus === 3
                    ? _c("span", [_vm._v("🚚")])
                    : _vm.deliveryInfo.DeliveryStatus === 4
                    ? _c("span", [_vm._v("✅")])
                    : _c("span", [_vm._v("📦")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hero-title" }, [
                  _vm._v(_vm._s(_vm.deliveryInfo.DeliveryStatusName))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hero-subtitle" }, [
                  _vm.deliveryInfo.DeliveryStatus === 2
                    ? _c("span", [
                        _vm._v("您的地址已提交，管理员将尽快为您安排发货")
                      ])
                    : _vm.deliveryInfo.DeliveryStatus === 3
                    ? _c("span", [_vm._v("证书已发出，请耐心等待签收")])
                    : _vm.deliveryInfo.DeliveryStatus === 4
                    ? _c("span", [_vm._v("证书已签收，祝您学习顺利")])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "info-card" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("收件人")]),
                _vm._v(" "),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.deliveryInfo.ReceiverName))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("联系电话")]),
                _vm._v(" "),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.deliveryInfo.ReceiverPhone))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("收货地址")]),
                _vm._v(" "),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.deliveryInfo.FullAddress))
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.deliveryInfo.ExpressCompany ||
            _vm.deliveryInfo.ExpressNo ||
            _vm.deliveryInfo.ShipTime
              ? _c("div", { staticClass: "info-card" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _vm.deliveryInfo.ExpressCompany
                    ? _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("快递公司")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(_vm._s(_vm.deliveryInfo.ExpressCompany))
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.deliveryInfo.ExpressNo
                    ? _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("快递单号")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "info-value info-value-mono" },
                          [_vm._v(_vm._s(_vm.deliveryInfo.ExpressNo))]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.deliveryInfo.ShipTime
                    ? _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("发货时间")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(
                            _vm._s(_vm.formatTime(_vm.deliveryInfo.ShipTime))
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.deliveryInfo.ReceiveTime
                    ? _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("签收时间")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(
                            _vm._s(_vm.formatTime(_vm.deliveryInfo.ReceiveTime))
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ]
        : [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "van-form",
              { staticClass: "address-form", on: { submit: _vm.onSubmit } },
              [
                _c(
                  "div",
                  { staticClass: "form-card" },
                  [
                    _c("van-field", {
                      attrs: {
                        name: "ReceiverName",
                        label: "收件人",
                        placeholder: "请输入收件人姓名",
                        rules: [{ required: true, message: "请输入收件人姓名" }]
                      },
                      model: {
                        value: _vm.form.ReceiverName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "ReceiverName", $$v)
                        },
                        expression: "form.ReceiverName"
                      }
                    }),
                    _vm._v(" "),
                    _c("van-field", {
                      attrs: {
                        name: "ReceiverPhone",
                        label: "联系电话",
                        type: "tel",
                        placeholder: "请输入联系电话",
                        rules: [
                          { required: true, message: "请输入联系电话" },
                          {
                            pattern: /^1[3-9]\d{9}$/,
                            message: "请输入正确的手机号"
                          }
                        ]
                      },
                      model: {
                        value: _vm.form.ReceiverPhone,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "ReceiverPhone", $$v)
                        },
                        expression: "form.ReceiverPhone"
                      }
                    }),
                    _vm._v(" "),
                    _c("van-field", {
                      attrs: {
                        "is-link": "",
                        readonly: "",
                        name: "area",
                        label: "所在地区",
                        placeholder: "请选择省市区",
                        rules: [{ required: true, message: "请选择所在地区" }]
                      },
                      on: {
                        click: function($event) {
                          _vm.showAreaPicker = true
                        }
                      },
                      model: {
                        value: _vm.areaText,
                        callback: function($$v) {
                          _vm.areaText = $$v
                        },
                        expression: "areaText"
                      }
                    }),
                    _vm._v(" "),
                    _c("van-field", {
                      attrs: {
                        name: "Address",
                        label: "详细地址",
                        type: "textarea",
                        rows: "2",
                        placeholder: "请输入详细地址（街道、门牌号等）",
                        rules: [{ required: true, message: "请输入详细地址" }]
                      },
                      model: {
                        value: _vm.form.Address,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "Address", $$v)
                        },
                        expression: "form.Address"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "submit-btn" },
                  [
                    _c(
                      "van-button",
                      {
                        attrs: {
                          round: "",
                          block: "",
                          color:
                            "linear-gradient(135deg, #ff6b5b 0%, #d51900 100%)",
                          "native-type": "submit",
                          loading: _vm.submitting,
                          "loading-text": "提交中..."
                        }
                      },
                      [_vm._v("\n          确认提交\n        ")]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "van-popup",
              {
                attrs: { position: "bottom" },
                model: {
                  value: _vm.showAreaPicker,
                  callback: function($$v) {
                    _vm.showAreaPicker = $$v
                  },
                  expression: "showAreaPicker"
                }
              },
              [
                _c("van-area", {
                  attrs: { "area-list": _vm.areaList },
                  on: {
                    confirm: _vm.onAreaConfirm,
                    cancel: function($event) {
                      _vm.showAreaPicker = false
                    }
                  }
                })
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-card-header" }, [
      _c("span", { staticClass: "info-card-title" }, [_vm._v("📍 收件信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-card-header" }, [
      _c("span", { staticClass: "info-card-title" }, [_vm._v("🚚 物流详情")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "status-hero hero-status-pending" }, [
      _c("div", { staticClass: "hero-icon" }, [_vm._v("📮")]),
      _vm._v(" "),
      _c("div", { staticClass: "hero-title" }, [_vm._v("填写收货地址")]),
      _vm._v(" "),
      _c("div", { staticClass: "hero-subtitle" }, [
        _vm._v("请认真填写您的收件信息，提交后由管理员为您安排发货")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26fc7a94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26fc7a94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/certificate_delivery.vue
// module id = null
// module chunks = 